import { applicationsApi } from 'api/applications'
import { store } from 'store'

/** Убирает http(s)://host — запрос идёт через API_URL (HTTPS), иначе mixed content на my.vedmarket.ru */
export function normalizeApplicationDownloadUrl(downloadUrl: string): string {
  const trimmed = downloadUrl.trim()
  if (!trimmed) {
    return trimmed
  }
  try {
    if (/^https?:\/\//i.test(trimmed)) {
      return new URL(trimmed).pathname.replace(/^\//, '')
    }
  } catch {
    // not a URL
  }
  return trimmed.replace(/^\//, '')
}

export async function downloadApplicationPreparedDocumentsZip(publicId: string) {
  const downloadUrl = `applications/v1.0/applications/${publicId}/prepared-documents/download/`
  const request = store.dispatch(applicationsApi.endpoints.downloadApplicationDocument.initiate(downloadUrl))
  try {
    const { objectUrl, disposition } = await request.unwrap()
    const filenameMatch = disposition.match(/filename="([^"]+)"/i)
    const filename = filenameMatch?.[1] || 'vedmarket-docs.zip'
    saveApplicationDocument({ objectUrl, filename })
  } finally {
    request.reset()
  }
}

export async function downloadApplicationDocument({ downloadUrl, filename }: ApplicationDownloadDocumentArgs) {
  const path = normalizeApplicationDownloadUrl(downloadUrl)
  const request = store.dispatch(applicationsApi.endpoints.downloadApplicationDocument.initiate(path))
  try {
    const { objectUrl } = await request.unwrap()
    saveApplicationDocument({ objectUrl, filename })
  } finally {
    request.reset()
  }
}

function saveApplicationDocument({ objectUrl, filename }: ApplicationSaveDocumentArgs) {
  const link = document.createElement('a')
  link.href = objectUrl
  link.download = filename
  link.click()
  URL.revokeObjectURL(objectUrl)
}
